module.exports = __webpack_public_path__ + "static/media/icon-gc-pro.d7a0a3ea.svg";